<template>
    <div class="person">
        <div class="condition">
            <div class="item">
                <div class="label" style="margin-right:20px">保险调查作业质量报表:</div>
                <el-radio-group v-model="type" @change="typeChange">
                    <el-radio label="责任保险">责任保险</el-radio>
                    <el-radio label="意外伤害保险">意外伤害保险</el-radio>
                    <el-radio label="健康保险">健康保险</el-radio>
                    <!-- <el-radio label="4">意外伤害保险</el-radio> -->

                </el-radio-group>
            </div>
            <!-- <div class="item">
                <div class="label">月份:</div>
                <el-date-picker
                v-model="conditionData.dataTime"
                type="month"
                size="small" 
                value-format="yyyy-MM-dd"
                placeholder="选择月"
                @change="typeChange">
                </el-date-picker>
            </div>
            <div class="item">
                <div class="label">时间段:</div>
                <el-date-picker
                v-model="conditionData.StartTime"
                size="small"
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="选择日期"
                @change="typeChange">
                </el-date-picker>
                ——
                <el-date-picker
                v-model="conditionData.EndTim"
                type="date"
                size="small"
                value-format="yyyy-MM-dd"
                placeholder="选择日期"
                @change="typeChange">
                </el-date-picker>
            </div> -->

            <div class="item">
                <div class="label">选择时间:</div>

                <el-date-picker
                v-model="conditionData.sdataTime"
                size="small"
                type="date"
                @change="typeChange"
                value-format="yyyy-MM-dd"
                placeholder="选择日期">
                </el-date-picker>
                ——
                <el-date-picker
                v-model="conditionData.edataTime"
                type="date"
                size="small"
                @change="typeChange"
                value-format="yyyy-MM-dd"
                placeholder="选择日期">
                </el-date-picker>
            </div>

            <div class="item" v-if="type==9">
                <div class="label">案件类型:</div>
                <el-select v-model="conditionData.cSvyModeCode" size="small" placeholder="请选择"  class="citem-input" @change="typeChange">
                    <el-option
                    v-for="item in cSvyModeList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                    </el-option>
                </el-select>
            </div>
            
            <!-- <div class="btns">
                <el-button type="primary" size="small" @click="selectData()">查询</el-button>
                <el-button type="" size="small" @click="reset()">重置</el-button>
            </div> -->
        </div>
        <div class="table">
            <div class="handle">
                <el-button type="" icon="el-icon-refresh-left" size="small" @click="loadingData()">刷新列表</el-button>
                <el-button type="success" size="small" icon="el-icon-download" @click="downloadExcel">导出数据</el-button>
            </div>
            <div class="title">
                {{type==1?'保险调查作业质量报表':'保险调查作业质量报表'}}
            </div>
            <el-table
                :data="tableData"
                border
                :header-cell-style="tableHeaderColor"
                height="600px"
                style="width: 100%"
                >
                <el-table-column
                type="index"
                label="序号"
                align="center"
                width="60"
                >
                </el-table-column>
                <el-table-column
                prop="mechanismName"
                label="作业机构"
                align="center"
                width="320"
                >
                </el-table-column>
                <el-table-column
                prop=""
                label="调查派工量"
                align="center"
                >
                    <el-table-column
                    prop="weekDcDispatch"
                    label="当周数据"
                    align="center"
                    >
                    </el-table-column>
                    <el-table-column
                    prop="monthDcDispatch"
                    label="本月累计"
                    align="center"
                    >
                    </el-table-column>
                </el-table-column>

                <el-table-column
                prop=""
                label="调查完成量"
                align="center"
                >
                    <el-table-column
                    prop="weekCompleteDcDispatch"
                    label="当周数据"
                    align="center"
                    >
                    </el-table-column>
                    <el-table-column
                    prop="monthCompleteDcDispatch"
                    label="本月累计"
                    align="center"
                    >
                    </el-table-column>
                </el-table-column>

                <el-table-column
                prop=""
                label="调查平均时效"
                align="center"
                >
                    <el-table-column
                    prop="weekDcAverage"
                    label="当周数据"
                    align="center"
                    >
                    </el-table-column>
                    <el-table-column
                    prop="monthDcAverage"
                    label="本月累计"
                    align="center"
                    >
                    </el-table-column>
                </el-table-column>

                <el-table-column
                prop=""
                label="调查阳性量"
                align="center"
                >
                    <el-table-column
                    prop="weekDcPositive"
                    label="当周数据"
                    align="center"
                    >
                    </el-table-column>
                    <el-table-column
                    prop="monthDcPositive"
                    label="本月累计"
                    align="center"
                    >
                    </el-table-column>
                </el-table-column>
                <el-table-column
                prop=""
                label="调查阳性率"
                align="center"
                >
                    <el-table-column
                    prop="monthDcPositiveRate"
                    label="本月累计"
                    align="center"
                    >
                    </el-table-column>
                </el-table-column>
                
                
            </el-table>


            <el-table
                :data="tableData"
                border
                :header-cell-style="tableHeaderColor"
                height="600px"
                style="width: 100%"
                v-if="type == '2'">
                <el-table-column
                type="index"
                label="序号"
                align="center"
                width="60"
                >
                </el-table-column>
                <el-table-column
                prop="mechanismName"
                label="作业机构"
                align="center"
                width="320"
                >
                </el-table-column>
                <el-table-column
                prop=""
                label="调查派工量"
                align="center"
                >
                    <el-table-column
                    prop="weekDcDispatch"
                    label="当周数据"
                    align="center"
                    >
                    </el-table-column>
                    <el-table-column
                    prop="monthDcDispatch"
                    label="本月累计"
                    align="center"
                    >
                    </el-table-column>
                </el-table-column>

                <el-table-column
                prop=""
                label="调查完成量"
                align="center"
                >
                    <el-table-column
                    prop="weekCompleteDcDispatch"
                    label="当周数据"
                    align="center"
                    >
                    </el-table-column>
                    <el-table-column
                    prop="monthCompleteDcDispatch"
                    label="本月累计"
                    align="center"
                    >
                    </el-table-column>
                </el-table-column>

                <el-table-column
                prop=""
                label="调查时效内结案"
                align="center"
                >
                    <el-table-column
                    prop="weekShClose"
                    label="当周数据"
                    align="center"
                    >
                    </el-table-column>
                    <el-table-column
                    prop="monthShClose"
                    label="本月累计"
                    align="center"
                    >
                    </el-table-column>
                </el-table-column>

                <el-table-column
                prop=""
                label="时效内结案率"
                align="center"
                >
                    <el-table-column
                    prop="monthShCloseRate"
                    label="本月累计"
                    align="center"
                    >
                    </el-table-column>
                </el-table-column>
                
                <el-table-column
                prop=""
                label="调查阳性量"
                align="center"
                >
                    <el-table-column
                    prop="weekDcPositive"
                    label="当周数据"
                    align="center"
                    >
                    </el-table-column>
                    <el-table-column
                    prop="monthDcPositive"
                    label="本月累计"
                    align="center"
                    >
                    </el-table-column>
                </el-table-column>
                <el-table-column
                prop=""
                label="调查阳性率"
                align="center"
                >
                    <el-table-column
                    prop="monthDcPositiveRate"
                    label="本月累计"
                    align="center"
                    >
                    </el-table-column>
                </el-table-column>
                
                
            </el-table>
        </div>
        


        
       
    </div>
</template>
<script>
import api from '../../../api/main'
import { insuranceList,cSvyModeList} from "../../../assets/selectList/anxin";
import { parseTime,parseTimeMM,parseTimeNowMM } from "../../../utils/index";

export default {
    name: 'person',
    components:{
        
    },
    watch: {
    },
    data () {
        return {
            cSvyModeList:cSvyModeList,
            insuranceList:insuranceList,
            title:'',
            isShow:false,
            isAddDialog:false,
            isUpdateDialog:false,
            totalCount:0,
            conditionData:{
                week: '',
                sdataTime:null,
                edataTime:null,
                cProdType:'',
                cSvyModeCode:'',
                operatorMechanismId:localStorage.getItem('mechanismid'),
            },
            tableData:[],

            type:'1',
        }
    },
    created(){
        

    },
    mounted(){
        // this.conditionData.dataTime = parseTimeNowMM()
        this.loadingData();
    },
    methods:{
        tableHeaderColor ({ row, column, rowIndex, columnIndex }) {
            if (rowIndex === 0) {
                return 'background-color: #F2F2F2;color: #000;'
            }
        },
        typeChange(){
           // alert(this.type);
            console.log(this.conditionData);
            this.selectData();
        },
        async loadingData() {
         
            let option = {
                cSvyModeCode:this.conditionData.cSvyModeCode,
                cProdType:this.type,
                sdataTime:this.conditionData.sdataTime,
                edataTime:this.conditionData.edataTime
            };
            let res = null;
            // if(this.conditionData.sdataTime){
            //     option.sdataTime = parseTimeMM(this.conditionData.sdataTime)
            // }
            // if(this.conditionData.edataTime){
            //     option.edataTime = parseTimeMM(this.conditionData.edataTime)
            // }
           
            res = await api.queryDataCensusDcTaskQualityAnXin(option);
            this.tableData = res.data.data;
        },

        selectData(){
            this.loadingData();
        },
        reset(){
            this.conditionData = {
                sdataTime:null,
                edataTime:null,
                cProdType:'',
                cSvyModeCode:'',
                
            },
            this.loadingData();
        },
        
        async downloadExcel(){
            let option = {};
            if(this.conditionData.dataTime){
                option.dataTime = this.conditionData.dataTime;
            }
            if(this.conditionData.cProdType){
                option.cProdType = this.conditionData.cProdType;
            }
            if(this.conditionData.cSvyModeCode){
                option.cSvyModeCode = this.conditionData.cSvyModeCode;
            }
            if(this.conditionData.StartTime){
                option.StartTime = this.conditionData.StartTime;
            }
            if(this.conditionData.EndTim){
                option.EndTim = this.conditionData.EndTim;
            }
            
            let type = this.type==1?7:8
            let name = this.type==1?'安心保险调查作业质量报表':'人保健保险调查作业质量报表'
            let res = await api.exportInventory({
                "type": type,
                "Condition":option
            },name);
        },

        weekChange(val) {
            console.log(val);
            let date = new Date(val)
            //一天的毫秒数  
            let millisecond = 1000 * 60 * 60 * 24;
            
            //获得当前周的第一天
            let currentWeekFirstDay = new Date(date.getTime() - (millisecond * (1))); 
            //获得当前周的最后一天
            let currentWeekLastDay = new Date(currentWeekFirstDay.getTime() + (millisecond * 6));
            this.conditionData.StartTime = parseTime(currentWeekFirstDay)
            this.conditionData.EndTim = parseTime(currentWeekLastDay)
            if (val) {
                this.conditionData.week = this.getWeekInMonth(new Date(val));
            }
            this.loadingData();
        },
        // 根据日期判断是月的第几周
        getWeekInMonth(t) {
            if (t == undefined || t == '' || t == null) {
                t = new Date();
            } else {
                var _t = new Date();
                _t.setYear(t.getFullYear());
                _t.setMonth(t.getMonth());
                _t.setDate(t.getDate());

                var date = _t.getDate(); //给定的日期是几号

                _t.setDate(1);
                var d = _t.getDay(); //1. 得到当前的1号是星期几。
                var fisrtWeekend = d;
                if (d == 0) {
                fisrtWeekend = 1;
                //1号就是星期天
                } else {
                fisrtWeekend = 7 - d + 1; //第一周的周未是几号
                }
                if (date <= fisrtWeekend) {
                return 1;
                } else {
                return 1 + Math.ceil((date - fisrtWeekend) / 7);
                }
            }
        },


    }
    
}
</script>

<style lang="scss" scoped>
    .condition{
        background-color: #ffffff;
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        border-radius: 5px;
        padding: 15px;
        font-size: 14px;
        .item{
            display: flex;
            align-items: center;
            padding: 10px;
            .label{
                min-width: 110px;
                padding-left: 10px;
            }
        }
        .btns{
            margin-left: 20px;
        }
    }
    .table{
        margin-top: 10px;
        background-color: #ffffff;
        padding: 15px;
        .title{
            width: 100%;
            text-align: center;
            margin-bottom: 10px;
            font-size: 18px;
            letter-spacing: 2px;
            font-weight: bold;
        }
        .handle{
            width: 100%;
            display: flex;
            justify-content: space-between;
            padding-bottom: 15px;
            align-items: center;
            font-size: 20px;
        }
        .page{
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-top: 16px;
            .el-pagination{
                margin-left: -10px;
            }
        }
    }

    .dialog{
        padding-top: 20px;
        height: 100%;
        .item{
            font-size: 14px;
            padding:10px 15px;
            .label{
                margin-bottom: 5px;
            }
        }
        
        .dialog-footer{
            display: flex;
            padding:10px 15px;
            flex-direction: row-reverse;
            .el-button{
                margin-left: 20px;
            }
        }
    }
</style>
